import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

interface SidebarGroupProps {
  icon: React.ElementType;
  label: string;
  collapsed: boolean;
  expanded: boolean;
  active?: boolean;
  visible?: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const SidebarGroup = ({
  icon: Icon,
  label,
  collapsed,
  expanded,
  active,
  visible,
  onToggle,
  children,
}: SidebarGroupProps) => {
  if (visible === false) {
    return null;
  }

  return (
    <>
      <button
        title={collapsed ? label : undefined}
        className={`sidebar-item ${active ? 'sidebar-item-active' : ''}`}
        onClick={onToggle}
      >
        <Icon size={22} className="sidebar-item-icon" />

        {!collapsed && (
          <>
            <span className="sidebar-item-label">{label}</span>

            <span
              style={{
                marginLeft: 'auto',
                color: 'var(--text-primary)',
              }}
            >
              {expanded ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
            </span>
          </>
        )}
      </button>

      {!collapsed && expanded && <div className="sidebar-submenu">{children}</div>}
    </>
  );
};

export default SidebarGroup;
